(() => {
  const homeRoot = document.querySelector('[data-loomforma-home]');
  if (!homeRoot) return;

  const mainCard = homeRoot.querySelector('[data-home-main-card]');
  const heroShell = homeRoot.querySelector('.loomforma-home-hero-shell');
  const heroBottom = homeRoot.querySelector('.loomforma-home-hero-bottom');
  const statement = homeRoot.querySelector('[data-home-statement]');
  const structuralOverlay = homeRoot.querySelector('.loomforma-home-structural-overlay');
  const enterLinks = homeRoot.querySelectorAll('[data-home-enter-link]');
  const enterUrl = homeRoot.dataset.enterUrl || '';
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const hasScrollTimeline =
    window.CSS?.supports('animation-timeline', 'scroll(root block)') &&
    window.CSS.supports('animation-range', '0px 40vh');
  const enterDuration = 620;
  let hasRedirected = false;
  let redirectTimer = null;
  let scrollFrame = null;
  let needsHeroMeasurement = true;
  let heroHeight = 1;
  let previousHeroProgress = -1;

  document.documentElement.style.overflowX = 'clip';
  document.body.style.overflowX = 'clip';

  const resetNavigationState = () => {
    window.clearTimeout(redirectTimer);
    redirectTimer = null;
    hasRedirected = false;
    homeRoot.classList.remove('is-entering');
    document.body.classList.remove('loomforma-home-locked');
  };

  const redirectToArchive = (url) => {
    if (!url || hasRedirected) return;
    hasRedirected = true;

    if (prefersReducedMotion) {
      window.location.assign(url);
      return;
    }

    homeRoot.classList.add('is-entering');
    document.body.classList.add('loomforma-home-locked');

    redirectTimer = window.setTimeout(() => {
      redirectTimer = null;
      window.location.assign(url);
    }, enterDuration);
  };

  const handleScrollState = () => {
    scrollFrame = null;
    if (!mainCard) return;

    if (needsHeroMeasurement) {
      // The CSS hero height stays stable while mobile browser toolbars collapse.
      heroHeight = heroShell?.clientHeight || window.innerHeight || 1;
      needsHeroMeasurement = false;
    }

    const scrollPos = Math.max(0, window.scrollY);
    const heroProgress = Math.min(1, scrollPos / (heroHeight * 0.4));
    // Safari's opacity-only fade leaves an invisible hit area unless it is inert.
    const heroHidden = heroProgress === 1;
    if (mainCard.inert !== heroHidden) mainCard.inert = heroHidden;
    if (!hasScrollTimeline && heroProgress !== previousHeroProgress) {
      const heroOpacity = `${1 - heroProgress}`;
      mainCard.style.opacity = heroOpacity;
      if (heroBottom) {
        heroBottom.style.opacity = heroOpacity;
        heroBottom.style.visibility = heroProgress === 1 ? 'hidden' : '';
      }
      previousHeroProgress = heroProgress;
    }

    if (!statement) return;
    const statementProgress = scrollPos / heroHeight;
    if (statementProgress > 0.3 && statementProgress < 0.8) {
      statement.classList.add('is-visible');
      const fadeIn = Math.min(1, (statementProgress - 0.3) * 3);
      const fadeOut = Math.max(0, 1 - Math.max(0, statementProgress - 0.5) * 3);
      statement.style.opacity = `${Math.min(1, fadeIn * fadeOut)}`;
    } else {
      statement.classList.remove('is-visible');
      statement.style.opacity = '0';
    }
  };

  const scheduleScrollState = () => {
    if (scrollFrame !== null) return;
    scrollFrame = window.requestAnimationFrame(handleScrollState);
  };

  const refreshScrollGeometry = () => {
    needsHeroMeasurement = true;
    scheduleScrollState();
  };

  enterLinks.forEach((link) => {
    link.addEventListener('click', (event) => {
      if (
        event.defaultPrevented || event.button !== 0 ||
        event.metaKey || event.ctrlKey || event.shiftKey || event.altKey ||
        link.hasAttribute('download') || (link.target && link.target !== '_self')
      ) return;
      const href = link.getAttribute('href') || enterUrl;
      if (!href) return;
      event.preventDefault();
      redirectToArchive(href);
    });
  });

  // Back/forward cache restores the DOM and JS flags from the outgoing page.
  window.addEventListener('pagehide', resetNavigationState);
  window.addEventListener('pageshow', (event) => {
    if (event.persisted) resetNavigationState();
    if (!prefersReducedMotion) refreshScrollGeometry();
  });

  if (structuralOverlay && !prefersReducedMotion) {
    window.setTimeout(() => {
      structuralOverlay.classList.add('is-ready');
    }, 800);
  } else if (structuralOverlay) {
    structuralOverlay.classList.add('is-ready');
  }

  if (!prefersReducedMotion) {
    window.addEventListener('scroll', scheduleScrollState, { passive: true });
    window.addEventListener('resize', refreshScrollGeometry, { passive: true });
    handleScrollState();
  }
})();
